import { Input, Form, Radio, DatePicker, Typography, FormInstance } from "antd";
import dayjs from "dayjs";
import "../../../App.css";
import SinglePackagePrice from "./SinglePackagePrice";

const DateAndPackagePricing = ({ form }: { form: FormInstance<any> }) => {
  return (
    <div className="w-[95%] md:w-[90%] xl:w-4/5">
      <Typography className="mb-1">
        Odaberi datume održavanja događaja
      </Typography>
      <div className="flex gap-8">
        <div>
          <Typography className="mb-1 ml-1 font-bold">1. dan</Typography>
          <Form.Item
            name="firstDayDate"
            rules={[
              {
                required: true,
                message: "Odaberi datum!",
              },
            ]}
          >
            <DatePicker
              className="rounded-sm xl:w-[144px]"
              placeholder="Odaberi datum"
              onChange={() => form.setFieldsValue({ secondDayDate: undefined })}
              disabledDate={(current) => !current || current.isBefore(dayjs())}
              allowClear={false}
            />
          </Form.Item>
        </div>

        <div>
          <Typography className="mb-1 ml-1 font-bold">2. dan</Typography>
          <Form.Item
            name="secondDayDate"
            rules={[
              {
                required: true,
                message: "Odaberi datum!",
              },
            ]}
          >
            <DatePicker
              className="rounded-sm xl:w-[144px]"
              placeholder="Odaberi datum"
              disabledDate={(current) =>
                !current ||
                current.isBefore(
                  form.getFieldsValue().firstDayDate &&
                    form.getFieldsValue().firstDayDate.add(1, "day"),
                  "day"
                )
              }
              allowClear={false}
            />
          </Form.Item>
        </div>
      </div>

      <div className="mt-5">
        <Typography>AKTIVNA CIJENA</Typography>

        <Form.Item
          name="priceType"
          rules={[
            {
              required: true,
              message: "Odaberi aktivnu cijenu!",
            },
          ]}
        >
          <Radio.Group>
            <Radio value={"regular"}>REDOVNA</Radio>
            <Radio value={"early-bird"}>EARLY BIRD</Radio>
          </Radio.Group>
        </Form.Item>
      </div>

      <div>
        <div className="xl:flex justify-between mb-4 xl:mb-0 gap-8 2xl:gap-16">
          <SinglePackagePrice
            form={form}
            priceType="regular"
            packageType="A"
            formItemNameKm="regularPriceKmA"
            formItemNameEur="regularPriceEurA"
          />
          <SinglePackagePrice
            form={form}
            priceType="early"
            packageType="A"
            formItemNameKm="earlyPriceKmA"
            formItemNameEur="earlyPriceEurA"
          />
        </div>
        <div className="xl:flex justify-between mb-4 xl:mb-0 gap-8 2xl:gap-16">
          <SinglePackagePrice
            form={form}
            priceType="regular"
            packageType="B"
            formItemNameKm="regularPriceKmB"
            formItemNameEur="regularPriceEurB"
          />
          <SinglePackagePrice
            form={form}
            priceType="early"
            packageType="B"
            formItemNameKm="earlyPriceKmB"
            formItemNameEur="earlyPriceEurB"
          />
        </div>
        <div className="xl:flex justify-between mb-4 xl:mb-0 gap-8 2xl:gap-16">
          <SinglePackagePrice
            form={form}
            priceType="regular"
            packageType="C"
            formItemNameKm="regularPriceKmC"
            formItemNameEur="regularPriceEurC"
          />
          <SinglePackagePrice
            form={form}
            priceType="early"
            packageType="C"
            formItemNameKm="earlyPriceKmC"
            formItemNameEur="earlyPriceEurC"
          />
        </div>
        <div className="xl:flex justify-between mb-4 xl:mb-0 gap-8 2xl:gap-16">
          <SinglePackagePrice
            form={form}
            priceType="regular"
            packageType="D"
            formItemNameKm="regularPriceKmD"
            formItemNameEur="regularPriceEurD"
          />
          <SinglePackagePrice
            form={form}
            priceType="early"
            packageType="D"
            formItemNameKm="earlyPriceKmD"
            formItemNameEur="earlyPriceEurD"
          />
        </div>
      </div>

      <Typography className="mt-3">PDV</Typography>
      <Form.Item
        name="VAT"
        rules={[
          {
            required: true,
            message: "Odaberi postotak PDV-a!",
          },
        ]}
        className="mt-1"
      >
        <Radio.Group>
          <Radio value={false}>0%</Radio>
          <Radio value={true}>17%</Radio>
        </Radio.Group>
      </Form.Item>
    </div>
  );
};

export default DateAndPackagePricing;
